"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useClient;

var _react = _interopRequireDefault(require("react"));

var _invariant = _interopRequireDefault(require("invariant"));

var _ApiCallContext = _interopRequireDefault(require("../ApiCallProvider/ApiCallContext"));

function useClient(clientCode) {
  var ctx = _react.default.useContext(_ApiCallContext.default);

  (0, _invariant.default)(ctx, "Call 'useClient' only inside of <ApiCallProvider>");
  var clients = ctx.clients;

  var client = _react.default.useMemo(function () {
    (0, _invariant.default)(clients[clientCode], "useClient: Client with code '".concat(clientCode, "' is not registered."));
    return clients[clientCode];
  }, [clients, clientCode]);

  return client;
}